var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12Z",
    fill: "#FC3F1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3704 17.9889H15.5445V5.52222H12.3796C9.1965 5.52222 7.52695 7.1515 7.52695 9.5588C7.52695 11.6366 8.6094 12.8082 10.5266 14.0805L11.6916 14.8494L10.1964 13.5954L7.2334 17.9889H9.59095L12.7558 13.2659L11.6549 12.5336C10.3248 11.6366 9.6735 10.9409 9.6735 9.43065C9.6735 8.1034 10.6092 7.2064 12.3888 7.2064H13.3612V17.9889H13.3704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexIcon);
export default __webpack_public_path__ + "static/media/yandex-icon.9e8330a89ccf6eb93789ec2985ec90b0.svg";
export { ForwardRef as ReactComponent };